<template>
  <div class="flex flex-col min-h-screen">
    <SiteHeader :page-name="'License Key Upload'" logout-only />
    <div class="w-full my-auto text-center">
      <LicenseKeyUploadPanel @uploaded="uploaded"></LicenseKeyUploadPanel>
    </div>
  </div>
</template>

<script setup lang="ts">
import LicenseKeyUploadPanel from "@/components/LicenseKeyUploadPanel.vue";

const router = useRouter();

const uploaded = (): void => {
  router.push({
    name: "admin-dashboard",
  });
};
</script>
